import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Box,
  Tooltip,
  Alert,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import { FaImage, FaVideo } from "react-icons/fa";

function MediaRequirementsAccordion() {
  return (
    <Accordion sx={{ mb: 2, bgcolor: "#e3f3fd" }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="media-requirements-content"
        id="media-requirements-header"
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="subtitle2">Media Requirements</Typography>
          <Tooltip
            title="Supported file formats and size limitations for media uploads"
            arrow
            placement="top"
          >
            <InfoIcon
              sx={{
                fontSize: 18,
                color: "text.secondary",
                "&:hover": { color: "primary.main" },
              }}
            />
          </Tooltip>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Alert
          severity="info"
          sx={{
            flexDirection: "column",
            alignItems: "flex-start",
            "& .MuiAlert-message": { width: "100%", p: 0 },
          }}
          icon={false}
        >
          <Box sx={{ p: 2, pb: 1 }}>
            <Typography variant="body2" fontWeight="medium">
              Supported file formats and size limitations
            </Typography>
          </Box>
          <List dense sx={{ width: "100%" }}>
            <ListItem>
              <ListItemIcon sx={{ minWidth: 32 }}>
                <FaImage size={14} />
              </ListItemIcon>
              <ListItemText
                primary="Images: JPEG, PNG, WEBP (Max 5MB)"
                secondary="Recommended: 800x418px aspect ratio"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon sx={{ minWidth: 32 }}>
                <FaVideo size={14} />
              </ListItemIcon>
              <ListItemText
                primary="Videos: MP4, 3GPP (Max 16MB)"
                secondary="Recommended: 30 seconds maximum"
              />
            </ListItem>
          </List>
        </Alert>
      </AccordionDetails>
    </Accordion>
  );
}

export default MediaRequirementsAccordion;
